// extracted by mini-css-extract-plugin
export default {"cls1":"oEAP3Z_MFGuWMvTLueVz","cls2":"vjzzxBo5tfc7Wp6O5Aff oEAP3Z_MFGuWMvTLueVz"};